import React from 'react'

import { EligibilityBadge } from './EligibilityBadge'
import { SegmentedOfferState } from '../../online_ordering/segmentedOfferUtils'
import { t } from 'src/translations'

export const OfferCardDetails = ({
  isSegmentedOffer,
  segmentState,
  isFreeDeliveryOffer,
  isApplied
}: {
  isSegmentedOffer: boolean
  segmentState: SegmentedOfferState
  isFreeDeliveryOffer?: boolean
  isApplied: boolean
}) => {
  const hideFreeDeliveryMessage =
    !isFreeDeliveryOffer || (isSegmentedOffer && segmentState !== 'eligible')
  const hideApplyMessage =
    isFreeDeliveryOffer || (isSegmentedOffer && segmentState !== 'eligible')
  return (
    <div className='cardDetails'>
      {segmentState === 'ineligible' && (
        <EligibilityBadge segmentState={segmentState} />
      )}
      {segmentState === 'logged-out' && t('offers.check-eligibility')}
      {!hideFreeDeliveryMessage && t('offers.automatically-applied')}
      {!hideApplyMessage &&
        (isApplied ? t('offers.applied') : t('offers.apply-at-checkout'))}
    </div>
  )
}
